export default __webpack_public_path__ + "static/media/haard-plast.541a32b0.svg";